import { getFullTokenUriMetadata } from '../datasource/Erc721DataSource'

export const getErc721TokenMetadataForToken = async (
  web3,
  erc721TokenContractAddress,
  tokenId
) => {
  return getFullTokenUriMetadata(web3, erc721TokenContractAddress, tokenId)
}
